export default ({ color, brand, category, type, status }) => {
  return [
    {
      label: 'Нэр',
      name: 'name',
      rules: [{required: true, message: 'Нэр оруулна уу'}],
      className: 'col-span-12 mb-1',
      inputProps: {
      }
    },
    {
      label: 'Үйлдвэрлэгч',
      name: 'manufacturer',
      rules: [{required: true, message: 'Үйлдвэрлэгч оруулна уу'}],
      className: 'col-span-12 mb-1',
      inputProps: {
        
      }
    },
    {
      label: 'Код',
      name: 'code',
      rules: [{required: true, message: 'Код оруулна уу'}],
      className: 'col-span-12 mb-1',
      inputProps: {
      }
    },
    {
      label: 'Хэмжээ',
      name: 'size',
      rules: [{required: true, message: 'Хэмжээ оруулна уу'}],
      className: 'col-span-12 mb-1',
      inputProps: {
        
      }
    },
    {
        label: 'Үнэ',
        name: 'price',
        rules: [{ required: true, message: 'Үнэ оруулна уу' }],
        className: 'col-span-6 mb-1',
        inputProps: {
        }
    },
    {
      label: 'Өнгө',
      name: 'color',
      type: 'color',
      rules: [{required: true, message: 'Өнгө оруулна уу'}],
      className: 'col-span-6 mb-1',
      inputProps: {
      }
    },
  
    {
      label: 'Ангилал',
      name: 'categoryid',
      type: 'select',
      rules: [{required: true, message: 'Ангилал оруулна уу'}],
      className: 'col-span-12 mb-1',
      inputProps: {
        options: category
      }
    },
  
    {
        label: 'Брэнд',
        name: 'brandid',
        type: 'select',
        rules: [{required: true, message: 'Брэнд оруулна уу'}],
        className: 'col-span-12 mb-1',
        inputProps: {
          options: brand
        }
      }, 
      {
        label: 'Төлөв',
        name: 'status',
        type: 'select',
        rules: [{required: true, message: 'Төлөв оруулна уу'}],
        className: 'col-span-12 mb-1',
        inputProps: {
          options: status
        }
      }, 
     {
      label: 'Тайлбар',
      name: 'description',
      type: 'textarea',
      rules: [{required: true, message: 'Тайлбар оруулна уу'}],
      className: 'col-span-12 mb-1',
      inputProps: {
      }
    },
  ]
}